import useContentful from "../hooks/use-contenful";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import BlockLeftImage from "./BlockLeftImage";
import Accordion from "./Accordion";
import { motion } from "framer-motion";
import "../css/blockpagos.css";

const query = `
query 
{
    videoTemplate(id: "5dRWa2kyTRIUt3GSPixfz1") {
        imageBlock2{url, title}
         contentBlock1{json}
         contentBlock2{json}
         contentBlock3{json}
         contentBlock4{json}
         contentBlock5{json}
         contentBlock6{json}
         contentBlock7{json}
         contentBlock8{json}
    }
  
}
`;

function DistanciaPagos() {
  let { data, errors } = useContentful(query);
  if (errors)
    return <span>{errors.map((error) => error.message).join(",")}</span>;
  if (!data) return <p>Loading...</p>;

  return (
    <div className="padding graybg">
      <div className="layout8 ">
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: {
              type: "spring",
              stiffness: 200,
            },
          }}
        >
          <div className="wrapper-pagos ">
            <center>
              {documentToReactComponents(data.videoTemplate.contentBlock1.json)}
            </center>
          </div>
        </motion.div>
      </div>

      <div className="wrapper-becas">
        <BlockLeftImage
          src={data.videoTemplate.imageBlock2.url}
          alt={data.videoTemplate.imageBlock2.title}
          content={
            <>
              {documentToReactComponents(data.videoTemplate.contentBlock2.json)}
              <div className="block-becas">
                <Accordion
                  title="Consulta las diversas opciones de becas que ofrecemos"
                  content={documentToReactComponents(
                    data.videoTemplate.contentBlock3.json
                  )}
                ></Accordion>
              </div>
            </>
          }
        ></BlockLeftImage>
      </div>

      <div className="layout8">
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: {
              type: "spring",
              stiffness: 200,
            },
          }}
        >
          <center>
            {documentToReactComponents(data.videoTemplate.contentBlock4.json)}
            {documentToReactComponents(data.videoTemplate.contentBlock5.json)}
          </center>
        
        </motion.div>
      </div>
      <div className="layout6">
       
        <Accordion
          title="Otros descuentos"
          content={documentToReactComponents(
            data.videoTemplate.contentBlock6.json
          )}
        ></Accordion>
        <Accordion
          title="Descuentos automáticos por rediseño"
          content={documentToReactComponents(
            data.videoTemplate.contentBlock7.json
          )}
        ></Accordion>
        <Accordion
          title="Plan de pagos"
          content={documentToReactComponents(
            data.videoTemplate.contentBlock8.json
          )}
        ></Accordion>
      </div>
    </div>
  );
}

export default DistanciaPagos;
